import React from 'react';
import './OverallRatingCard.css';

const OverallRatingCard = ({ rating }) => {
  const renderStars = (count) => {
    return '⭐'.repeat(5);
  };

  return (
    <div className="overall-rating-card">
      <div className="rating-left">
        <div className="rating-number-large">{rating.average.toFixed(1)}</div>
        <div className="stars-display">
          {renderStars(5)}
        </div>
        <div className="reviews-count">Based on {rating.totalReviews.toLocaleString()} reviews</div>
        <div className="growth-indicator positive">
          +{rating.growth} from last month
        </div>
      </div>

      <div className="rating-right">
        <h3 className="distribution-title">Rating Distribution</h3>
        <div className="rating-bars">
          {[5, 4, 3, 2, 1].map(starCount => {
            const data = rating.distribution[starCount];
            return (
              <div key={starCount} className="rating-bar-row">
                <div className="star-label">
                  {starCount} ⭐
                </div>
                <div className="progress-bar-wrapper">
                  <div
                    className="progress-bar-fill"
                    style={{ width: `${data.percentage}%` }}
                  />
                </div>
                <div className="bar-count">({data.count})</div>
                <div className="bar-percentage">{data.percentage}%</div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default OverallRatingCard;

